import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSwapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#FE5000" d="M5 16v-3h11v-2H5V8H4l-4 4 4 4zM11 8V5H0V3h11V0h1l4 4-4 4z" />
  </svg>
);
export default SvgSwapIcon;
